export default "__VITE_ASSET__FQQ09zQY__"